import { render, staticRenderFns } from "./IncomingOrders.vue?vue&type=template&id=289744aa&scoped=true"
import script from "./IncomingOrders.vue?vue&type=script&lang=js"
export * from "./IncomingOrders.vue?vue&type=script&lang=js"
import style0 from "./IncomingOrders.vue?vue&type=style&index=0&id=289744aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289744aa",
  null
  
)

export default component.exports